export default __webpack_public_path__ + "static/media/FAC1.f3edc895.jpg";